import React, { useEffect, useRef, useState } from "react";
import AllBestData from "./AllBestData";
import MexpPassTRks from "./MexpPassTRks";
import Speed from "./Speed";
import PunctualityMexpPass from "./PunctualityMexpPass";
import TYLoadingData from "./TenYearsData.jsx/TYLoadingData";
import { FaChartLine } from "react-icons/fa";
import { IoBarChartOutline, IoBarChartSharp } from "react-icons/io5";
import { FaTableList } from "react-icons/fa6";
import { CiViewTable } from "react-icons/ci";
import TableView from "./TableView";
import GraphView from "./GraphView";
import { useChartContext } from "../../Context/ChartsContext";
import PunctualityVSTotalTrain from "./PunctualityVS";
import PunctualityVS from "./PunctualityVS";
import Print from "../../Extra/Print";
const BestDataMaster = () => {
  const { fetchBestSheetData } = useChartContext();
  const [showGraph, setShowGraph] = useState(true);
  const [showTable, setShowTable] = useState(false);
  const printRef = useRef();
  useEffect(() => {
    fetchBestSheetData();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div className="">
      <div ref={printRef}>
        <div
          className="  p-3 newUiBody"
          // style={{ background: "rgba(174, 214, 241, 0.5)" }}
        >
          <div className="row">
            <div className="col-md-7 " style={{ fontSize: "10px" }}>
              <div
                className="Subject "
                // style={{ background: "rgba(255, 255, 255, 1)" }}
              >
                <AllBestData />
              </div>
            </div>
            <div className="col-md-5 col-12 " style={{ fontSize: "10px" }}>
              <div className="col-md-12 ">
                <div
                  className="Subject "
                  style={{ background: "rgba(255, 255, 255, 0.7)" }}
                >
                  <MexpPassTRks />
                </div>
              </div>
              <div className="col-md-12 mt-2">
                <div
                  className="Subject "
                  style={{ background: "rgba(255, 255, 255, 0.7)" }}
                >
                  <PunctualityMexpPass />
                </div>
              </div>
            </div>
          </div>
          <div className="newUiBody m-1">
            <div className="row ">
              <div className="col-md-6">
                <PunctualityVS vs={"TotalTrain"} />
              </div>{" "}
              <div className="col-md-6">
                <PunctualityVS vs={"LDG_WGN"} />
              </div>{" "}
              {/* <div className="col-md-4">
              <PunctualityVS />
            </div> */}
            </div>
          </div>
        </div>
        <div
          className="p-3 newUiBody "
          style={
            {
              // background: "rgba(163, 228, 215 ,0.5)",
            }
          }
        >
          <div className="d-flex justify-content-end p-1  ">
            <button
              className={`btn  btn-sm btn-outline-dark d-flex align-item-center me-1
                  ${showGraph ? "active" : ""}
                 `}
              style={{ height: "25px" }}
              onClick={() => {
                setShowGraph(!showGraph);
                setShowTable(!showTable);
              }}
            >
              {showGraph ? <IoBarChartSharp /> : <IoBarChartOutline />}
            </button>
            <button
              className={`btn  btn-sm btn-outline-dark d-flex align-item-center 
                  ${showTable ? "active" : ""}
                 `}
              style={{ height: "25px" }}
              onClick={() => {
                setShowTable(!showTable);
                setShowGraph(!showGraph);
              }}
            >
              {showTable ? <FaTableList /> : <CiViewTable />}
            </button>
          </div>
          {showTable && <TableView />}
          {showGraph && <GraphView />}
        </div>
      </div>
      <Print title={`op -`} printRef={printRef} />
    </div>
  );
};
export default BestDataMaster;
